import React from "react";
import { Link } from "react-router-dom";
import { category_blog } from "./data";
function Category_sidebar(){
    return(
        <div className="category-post sidebar-widget">
            <h2>دسته بندی مقالات</h2>
            <ul>
            {
                category_blog.map((cat)=>{
                    return(
                        
                            <li key={cat.id}>
                                <Link to="cat">{cat.title}</Link>
                                <span className="post-count">( {cat.post_count} )</span>
                            </li>
                    );
                })
            }
            </ul>
        </div>
    );
}

export default Category_sidebar;